import { render } from "./AppSettingsDrawer.vue?vue&type=template&id=5d21e9b2&scoped=true"
import script from "./AppSettingsDrawer.vue?vue&type=script&lang=js"
export * from "./AppSettingsDrawer.vue?vue&type=script&lang=js"

import "./AppSettingsDrawer.vue?vue&type=style&index=0&id=5d21e9b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d21e9b2"]])

export default __exports__